<template>
  <div id="app">
<!--   <div id="poem-header"></div> -->
    <!-- <img src="./assets/logo.png"> -->

    <navbar />
    <transition name="fade">
    <router-view></router-view>
    </transition>

    <footbar />

  </div>
</template>

<script>
import footbar from './components/Footbar.vue'
import navbar from './components/Navbar.vue'

export default {
  name: 'app',
  components: { footbar, navbar }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ADADAD;
  background-color: #FFF;
}
img {
  width: 100%;
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.ralph-pink {
  background-color: #E6007E;
}
.ralph-blue {
  background-color: #00BDC0;
}
.ralph-orange {
  background-color: #FB6718;
}
.ralph-green {
  background-color: #33B456;
}
.ralph-yellow {
  background-color: #FCC100;
}
</style>



// WEBPACK FOOTER //
// App.vue?693f8c42